import { useContext } from "react";
import { ReactionStyles, ReactionRow } from "./Chat.styles";
import { SocketContext } from "../../context/SocketContext";
import { MediaContext } from "../../context/MediaContext";

export const Reactions = ({ message, values, dark }) => {
  const reactionList = ["fa-thumbs-up", "fa-heart", "fa-grin-tears", "fa-sad-tear", "fa-angry"];

  const { sendSocketEvent } = useContext(SocketContext);
  const { getVideoTs } = useContext(MediaContext);

  const onClickReaction = (index) => {
    return () =>
      sendSocketEvent("chat/reaction", {
        uuid: message.uuid,
        value: index + 5,
        videoTs: getVideoTs(),
      });
  };

  const noReactions = values.reduce((acc, curr) => acc + curr.value, 0) === 0;

  return (
    <ReactionRow dark={dark} className="justify-content-center w-auto px-2 reaction-bar">
      {reactionList.map((reaction, index) => {
        const reactObj = values[index];

        return (
          <ReactionStyles
            key={index}
            visible={reactObj.value > 0}
            userReacted={reactObj.userReacted}
            className="w-auto p-1 reaction"
          >
            <Reaction reaction={reaction} onClick={onClickReaction(index)} />
            <span className="w-auto fs-5">{reactObj.value}</span>
          </ReactionStyles>
        );
      })}
      {noReactions && <i className="placeholder-reaction w-auto mt-2 p-1 fs-5 fas fa-grin" />}
    </ReactionRow>
  );
};

const Reaction = ({ reaction, onClick }) => {
  return <i className={`w-auto fas ${reaction}`} onClick={onClick} />;
};
